import React, { useEffect } from "react";
import { Card, Row, Col, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "../contraRecordSlice";
import RecordDateFilter from "../../../../components/filters/RecordDateFilter";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import { fetchContraRecord } from "../contraRecordThunk";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";

const ContraRecordFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.contraRecord);

  useDefaultDateRange(setFilters, filters, "today");

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };


  const handleSubmit = () => {
    if (!filters.filterType) {
      messageApi.warning("Select Filter Type");
      return;
    }
    dispatch(fetchContraRecord({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch report ❌");
      }
    });
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={[16, 16]} style={{ alignItems: "center" }}>
        {/* Filter Type */}
        <Col xs={24} sm={12} md={12} lg={8} xl={6}>
          <label>Filter Type</label>
          <SearchListAutoComplete
            optionsList={[{ sale_id: "All", display_text: "All" }]}
            value={{ value: filters.filterType, label: filters.filterType }}
            onSelect={(obj) => handleFilterChange("filterType", obj?.sale_id)}
            placeholder="Filter Type"
            showAddNew={false}
          />
        </Col>

        {/* Date Filter */}
        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
          handleFilterChange("fromDate", fromDate);
          handleFilterChange("toDate", toDate);
          }}
        />

        {/* Submit */}
       <Col xs={24} sm={12} md={4} lg={4} xl={4} style={{ display: "flex", alignItems: "flex-end", height: 58 }} >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSubmit}
            style={{height: 35.19}}
            block
          >
            Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default ContraRecordFilters;
